import { AUTHORIZATION_TYPE } from '../utils/authorization'
import { UNIT } from '../utils/currency'

export const getIsLock = (userType, component) => {
  return component[userType.userTypeId] === AUTHORIZATION_TYPE.DISABLE
}

export const calculateMinUnit = ({ values, oldUnit }) => {
  if (!values || !values.length) return oldUnit

  const validValues = values.filter(Boolean).map(Math.abs)
  const min = Math.min(...validValues)
  let unit

  switch (true) {
    case min < 1e6:
      unit = UNIT.SINGLE.unitKey
      break
    case min >= 1e6 && min < 1e9:
      unit = UNIT.MILLION.unitKey
      break
    case min >= 1e9 && min < 1e12:
      unit = UNIT.BILLION.unitKey
      break
    default:
      unit = UNIT.TRILLION.unitKey
      break
  }

  return UNIT[unit].multiplier > UNIT[oldUnit].multiplier ? unit : oldUnit
}
